import {
  COMPONENT_DEFINITION_METADATA_KEY,
  COMPONENT_ID_METADATA_KEY
} from './metadata-keys';
import { setMetadata } from '@digitaix/helpers';
import { ComponentDefinitionMeta } from '@digitaix/types';

export function DxComponentMeta<T>(id: string, meta: Partial<ComponentDefinitionMeta<T>> = {}) {
  return function(target: any) {
    setMetadata(COMPONENT_ID_METADATA_KEY, id, target);
    setMetadata(COMPONENT_DEFINITION_METADATA_KEY, {
      actionBar: [],
      ...meta,
      title: meta.title || `COMPONENTS.${id}.title`
    } as ComponentDefinitionMeta<T>, target);
  }
}
